// extracted by mini-css-extract-plugin
module.exports = {"main-component":"calendar_main-component__SJet2"};